import script from "./stockMx.vue?vue&type=script&setup=true&lang=js"
export * from "./stockMx.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__